/** Curated naming vocabulary. Gameplay randomness never uses these UI draws. */
const adjectiveSource =
    `Bold Blue Swift Warm Gold Grim Brisk Keen Sly Stout Crisp Odd Snug Spry Stark Vast Wry Posh Lush Sleek Fierce Shy Quaint Glum Red Wild Dark Bright Smug Prime Fond Dire Tart Trim Grand Proud Brave Calm Deep Fresh Black White Green Grey Brown Pink Mauve Tan Teal Pale Fair Cold Cool Hot Chill Dry Wet Damp Rich Poor Cheap Dear Fine Good Great Best Smart Wise Young Old New Fresh Stale Quick Slow Fast Fleet Light Dark Loud Soft Hard Tough Strong Weak Mild Sweet Sour Sharp Blunt Long Short Tall Small Big Huge High Low Wide Thin Thick Fat Lean Broad Close Far Near Full Bare Blank Clean Neat Tidy Nice Kind Mean Rude Sane Mad Daft Droll Dull Faint Firm Frail Grown Hale Meek Rapt Shrewd Sore Staid Suave Tame Taut Vague Vexed Blithe Bleak Clear Cross Cute Deep Dense Free Glad Green Gruff Hushed Just Late Loose Lost Low Lame Lithe Live Loved Mere Moist Mute Plain Plush Pure Rare Raw Real Ripe Rough Round Safe Salt Scant Scarce Shorn Shrewd Sick Slight Slim Smooth Sole Sound Spare Steep Stern Stiff Still Strange Strict Striped Sure Sweet Swift Thick Thrift True Vain Warm Worn Wrong Young Zest`.split(
        /\s+/,
    );
const nounSource =
    `Lich Nymph Fae Wight Droid Core Void Wraith Forge Rune Hearth Mech Star Fox Crow Wren Lynx Knight Mage Witch Bard Rogue Sage Crown Throne Gem Quill Coin Dice Pawn Gear Bolt Tide Flame Peak Grove Moth Whale Drum Bell Key Mask Woman Swan Hawk Bear Reef Toad Ghost Duke Seer Crag Brook Wasp Boar Lark Chest King Queen Prince Crone Scout Guard Monk Priest Thief Wolf Stag Hare Bat Rat Rook Gull Bee Eel Shark Crab Claw Fang Horn Hoof Wing Tail Scale Pelt Mane Shell Snail Slug Snake Newt Frog Fish Bass Pike Trout Cod Carp Perch Squid Clam Prawn Seal Mole Shrew Mouse Moose Elk Ram Lamb Goat Sheep Ox Bull Cow Calf Colt Horse Mare Foal Pig Sow Dog Hound Cat Pup Finch Jay Kite Dove Goose Duck Hen Cock Chick Crane Quail Snipe Stork Swift Thrush Grub Ant Fly Gnat Flea Tick Bug Worm Drake Wyrm Troll Orc Elf Gnome Dwarf Imp Fiend Beast Sprite Shade Soul Skull Bone Tooth Blood Heart Fist Hand Arm Palm Thumb Eye Brow Cheek Chin Beak Ear Face Head Hair Beard Neck Back Knee Foot Toe Nail King Lord Earl Count Jarl Squire Page Serf Knave Fool Clown Child Boy Girl Man Son Bride Dame Miss Saint Nun Chief Judge Host Guest Friend Foe Mate Pal Crew Tribe Clan House Hall Den Keep Fort Spire Tower Tomb Vault Cave Lair Crypt Pit Rift Gate Wall Arch Realm Zone Bay Dock Base Loft Nook Shed Booth Nest Lodge Bridge Port Town Court Square Street Road Lane Path Trail Track Field Farm Barn Mill Shop Bank Inn Pub Bar Club Tent Hut Shack Camp Yard Lawn Park Wood Tree Branch Trunk Leaf Bark Root Seed Sprout Bud Bloom Rose Thorn Vine Fern Moss Grass Reed Rush Oak Pine Birch Ash Elm Yew Beech Palm Fir Spruce Larch Fruit Plum Peach Pear Grape Fig Date Lime Corn Wheat Rye Oat Rice Bean Pea Nut Clove Mint Sage Spice Salt Soup Bread Cake Pie Tart Jam Curd Cheese Cream Egg Meat Ham Steak Roast Fish Feast Ale Beer Mead Wine Rum Gin Tea Juice Milk Ice Snow Rain Hail Sleet Frost Mist Fog Cloud Wind Storm Gale Breeze Sun Moon Dawn Dusk Night Day Noon Sky Ray Beam Glow Light Spark Flash Blaze Coal Fire Smoke Steam Stone Rock Flint Slate Shale Chalk Clay Sand Mud Dirt Dust Silt Gold Steel Brass Bronze Chrome Tin Lead Zinc Iron Ore Glass Gem Pearl Jade Quartz Flint Sword Axe Blade Spear Pike Bow Dart Sling Mace Club Staff Wand Rod Shield Helm Mail Plate Cloak Cape Boot Glove Belt Ring Brooch Chain Rope Cord Thread Cloth Silk Wool Felt Lace Flag Scroll Book Page Pen Ink Map Chart Word Verse Song Chord Note Tune Drum Flute Horn Gong Harp Lute Pipe Lyre Game Chess Check Move Turn Roll Draw Deck Card Suit Ace Jack King Queen Trump Chip Pot Bet Stake Win Loss Score Point Goal Ball Bat Puck Die Cube Disc Orb Globe Wheel Cog Screw Nail Pin Lock Latch Hook Knob Pump Valve Spring Wire Lens Scope Clock Watch Sand Ship Boat Yacht Skiff Barge Raft Sail Oar Mast Hull Keel Rail Train Tram Car Bus Truck Van Bike Cart Sled Sleigh Plane Jet Wing Drone Craft Ark Bench Chair Couch Bed Cot Crib Shelf Rack Chest Crate Box Bag Sack Pouch Case Cup Mug Bowl Plate Fork Spoon Knife Dish Jug Jar Pot Pan Tray Can Bin Tub Sink Well Tap Pool Pond Lake Loch Stream Brook Creek Falls Wave Surf Shore Coast Beach Isle Reef Cape Cliff Ridge Hill Mound Mount Peak Crag Slope Vale Dale Glen Moor Heath Marsh Bog Swamp Fen Cave Depth Chasm Gorge Ravine Rift Fault Forge Hearth Rune Wraith Mech Star Quill Coin Dice Pawn Gear Bolt Tide Flame Grove`.split(
        /\s+/,
    );
export const adjectives = [...new Set(adjectiveSource)].filter(
    (word) => !["Tidy", "Thrift", "Zest"].includes(word),
);
export const nouns = [...new Set(nounSource)].filter(
    (word) =>
        ![
            "Tower",
            "Iron",
            "Ravine",
            "Chasm",
            "Fire",
            "Lyre",
            "Squire",
            "Wire",
            "Cock",
        ].includes(word),
);
export const gameAdjectives = adjectives;
export const gameNouns = nouns;
export const roomPrefixes = [
    "A",
    "The",
    "My",
    "Our",
    "First",
    "Second",
    "Third",
    "Fourth",
    "Fifth",
    "Sixth",
    "Seventh",
];
export const roomAdjectives =
    `Red Blue Green White Yellow Black Purple Grey Gaming Sleeping Winning Losing Cheering Fuzzy Fluffy Cozy Dusty Hidden Sunny Moonlit Candlelit Crooked Creaky Toasty Sleepy Rowdy Merry Quiet Secret Lucky Wonky Wobbly Mossy Velvet Golden Starlit Enchanted Haunted Amber Echoing Ancient Orange Icy Eerie Airy Open Arched Emerald Rustic Jovial Peaceful Wild Brave Silver Sapphire Crimson Copper Scarlet Indigo Rosy Snowy Misty Stormy Shady Breezy Bright Warm Cool Frosty Daring Drowsy Electric Epic Fantastic Festive Friendly Gentle Grand Happy Humble Jolly Kind Laughing Lively Lovely Magical Noble Odd Playful Proud Quirky Relaxed Royal Serene Shimmering Spirited Splendid Spooky Tidy Twinkling Welcoming Whispering Wistful Wooden Woolly Wondrous Zany First Second Third Fourth Fifth Sixth Seventh`
        .split(/\s+/)
        .concat(["Geek's", "Nerd's", "Jock's"]);
export const roomNouns = [
    "Table",
    "Game Table",
    "Mead Hall",
    "Hall",
    "Den",
    "Kitchen",
    "Dining Room",
    "Bedroom",
    "Living Room",
    "Room",
    "Foyer",
    "Dungeon",
    "Graveyard",
    "Tea Room",
    "Porch",
    "Front Porch",
    "Back Porch",
    "Deck",
    "Sunroom",
    "Backyard",
    "Schoolyard",
    "Gym",
    "Space",
    "Cafeteria",
    "Floor",
    "Game Store",
    "Mall",
    "Station",
    "Keep",
    "Fort",
    "Spire",
    "Tower",
    "Tomb",
    "Vault",
    "Cave",
    "Lair",
    "Crypt",
    "Pit",
    "Rift",
    "Gate",
    "Wall",
    "Arch",
    "Realm",
    "Zone",
    "Bay",
    "Dock",
    "Base",
    "Attic",
    "Loft",
    "Nook",
    "Alcove",
    "Pantry",
    "Cellar",
    "Study",
    "Library",
    "Parlor",
    "Workshop",
    "Garage",
    "Shed",
    "Cabin",
    "Hearth",
    "Booth",
    "Burrow",
    "Hideout",
    "Nest",
    "Lodge",
    "Bunker",
    "Bridge",
    "Hangar",
    "Outpost",
];
// Pronunciation metadata is deliberately curated, including consonant-sounding words.
const anWords = new Set([
    "Enchanted",
    "Amber",
    "Echoing",
    "Ancient",
    "Orange",
    "Icy",
    "Eerie",
    "Airy",
    "Open",
    "Arched",
    "Emerald",
    "Electric",
    "Epic",
    "Odd",
    "Attic",
    "Alcove",
    "Arch",
    "Outpost",
]);
const ordinal = new Set(roomPrefixes.slice(4));
export interface RoomNameParts {
    prefix: string;
    adjective: string;
    noun: string;
}
export function combineRoomName({ prefix, adjective, noun }: RoomNameParts) {
    const first = adjective || noun;
    return [
        prefix === "A" ? (anWords.has(first) ? "An" : "A") : prefix,
        adjective,
        noun,
    ]
        .filter(Boolean)
        .join(" ");
}
const pick = (words: readonly string[], random: () => number) =>
    words[Math.min(words.length - 1, Math.floor(random() * words.length))]!;
export function generateRoomName(random = Math.random): RoomNameParts {
    const prefix = pick(roomPrefixes, random);
    return {
        prefix,
        adjective: pick(
            roomAdjectives.filter(
                (a) => !(ordinal.has(prefix) && ordinal.has(a)),
            ),
            random,
        ),
        noun: pick(roomNouns, random),
    };
}
export function generateGameName(
    current = "",
    random = Math.random,
    occupied: readonly string[] = [],
) {
    const [oldAdjective, oldNoun] = current.split(" ");
    const nextAdjectives = adjectives.filter((word) => word !== oldAdjective);
    const nextNouns = nouns.filter((word) => word !== oldNoun);
    let candidate = "";
    // Only admitted room names are passed by the form. Cosmetic collisions do not require uniqueness.
    for (let attempt = 0; attempt < 8; attempt++) {
        candidate = `${pick(nextAdjectives, random)} ${pick(nextNouns, random)}`;
        if (!occupied.includes(candidate)) break;
    }
    return candidate;
}
